'use strict';
import ApiActions from '../../../actions/api';
import Constants from './constants';
import Store from './store';
import Log from '../../../helpers/log';
import ObjectAssign from 'object-assign';

class Actions {
    static sendMessage(data) {

        data = ObjectAssign(Log.getClientDetails(), data);

        ApiActions.post(
            '/api/contact',
            data,
            Store,
            Constants.SEND_MESSAGE,
            Constants.SEND_MESSAGE_RESPONSE
        );
    }

    static reset() {
        Store.dispatch({
            type: Constants.RESET
        });
    }
}


export default Actions;
